import { LocalizedText, useDialogAction } from '@mews/framework';
import { Button } from '@optimus-web/core';
import { WithAccountId } from '@mews-commander/types';
import { TextKey, DataTestId } from '@mews-commander/enums';
import { PaymentPlan } from '@mews-commander/data-access';
import { CancelPaymentPlanDialog } from '../../tables/PaymentPlans/CancelPaymentPlanDialog';
import { useCancelPaymentPlan } from '../../tables/PaymentPlans/queries';
import { WithPaymentPlanId } from '../../tables/PaymentPlans/types';

export const PaymentPlanDetailsCancelPlan = ({
    paymentPlanId,
    accountId,
    paymentMethodData,
}: WithPaymentPlanId & WithAccountId & { paymentMethodData?: PaymentPlan['paymentMethodData'] }) => {
    const { mutateAsync } = useCancelPaymentPlan({
        accountId,
        paymentMethodId: paymentMethodData?.value?.id,
        paymentMethod: paymentMethodData?.discriminator,
    });
    const cancellationAction = useDialogAction(async () => await mutateAsync({ id: paymentPlanId }));

    return (
        <>
            <Button
                size="medium"
                type="button"
                data-test-id={DataTestId.CancelPaymentPlanButton}
                onClick={cancellationAction.handlers.handleOpen}
            >
                <LocalizedText textKey={TextKey.CancelPaymentPlan} />
            </Button>
            <CancelPaymentPlanDialog actions={cancellationAction} />
        </>
    );
};
